import React from "react";
import TickList from "../tick-list/TickList";

const listItems = [
  "Read information on our <a href='https://www.johnlewis.com/customer-services/delivery-information'>delivery options and services<a/>",
];

function GeneralDeliveryQueries() {
  return (
    <div>
      <section>
        <h2>Help with delivery information</h2>
        <p>Before getting in touch, you may wish to check the following:</p>
        <TickList squeezed items={listItems} />
      </section>
    </div>
  );
}

export default GeneralDeliveryQueries;
